// components/PlanExpiredOverlay.jsx
import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

const PlanExpiredOverlay = ({ onRenew, onLogout }) => {
  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-white max-w-md w-full mx-4 rounded-2xl shadow-2xl p-8 text-center animate-in fade-in zoom-in-95 duration-200">
        <div className="flex justify-center mb-4">
          <div className="bg-red-100 p-4 rounded-full">
            <FaExclamationTriangle className="h-12 w-12 text-red-600" />
          </div>
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          Your Plan Has Expired
        </h2>
        <p className="text-gray-600 mb-6">
          To continue using all features, please renew your subscription or
          upgrade to a new plan.
        </p>
        <button
          onClick={onRenew}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition shadow-lg"
        >
          Renew / Upgrade Plan
        </button>
        <button
          onClick={onLogout}
          className="w-full bg-transparent hover:bg-gray-100 text-gray-600 font-medium py-2 px-6 rounded-lg border border-gray-300 transition"
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default PlanExpiredOverlay;
